<style scoped>
/* ===== 布局容器 ===== */
.layout-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ===== 顶部导航栏 ===== */
.navbar {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 20px;
  background: var(--navbar-bg, #fff);
  border-bottom: 1px solid var(--border-color-light, #e5e6eb);
  position: relative;
  z-index: 100;
  flex-shrink: 0;
}
.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin-right: 24px;
  flex-shrink: 0;
}
.logo-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #165DFF, #0E42D2);
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #1d2129;
  letter-spacing: 0.5px;
}

/* 一级菜单Tab */
.top-menu-tabs {
  display: flex;
  align-items: center;
  height: 56px;
  gap: 2px;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}
.top-menu-tabs::-webkit-scrollbar {
  display: none;
}
.top-tab {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 18px;
  height: 56px;
  cursor: pointer;
  font-size: 14px;
  color: #86909c;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  white-space: nowrap;
}
.top-tab:hover {
  color: #165DFF;
}
.top-tab.active {
  color: #165DFF;
  font-weight: 600;
  border-bottom-color: #165DFF;
}

/* 右侧操作区 */
.navbar-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding-left: 16px;
}
.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
  color: #4e5969;
  transition: all 0.15s;
  position: relative;
}
.action-btn:hover {
  color: #165DFF;
  background: rgb(var(--gray-2));
}

.msg-dot {
  position: absolute;
  top: 4px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #f53f3f;
  border: 2px solid #fff;
  color: #fff;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  font-weight: 600;
  padding: 0 3px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.85);
}

.user-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 12px 3px 4px;
  margin-left: 8px;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.15s;
}
.user-trigger:hover {
  background: rgb(var(--gray-2));
}
.user-name {
  font-size: 13px;
  color: #1d2129;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 主题切换下拉选项 */
.theme-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 13px;
  color: #4e5969;
  cursor: pointer;
  transition: all 0.15s;
}
.theme-option:hover { background: rgb(var(--gray-1)); color: #165DFF; }
.theme-option.active { color: #165DFF; font-weight: 500; }

.user-panel {
  min-width: 200px;
  padding: 8px 0;
  height: auto;
  overflow: hidden;
}
.panel-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  margin-bottom: 4px;
}
.panel-avatar {
  flex-shrink: 0;
}
.panel-detail {
  min-width: 0;
}
.panel-name {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  line-height: 1.3;
}
.panel-desc {
  font-size: 12px;
  color: #86909c;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.panel-divider {
  height: 1px;
  background: #f2f3f5;
  margin: 4px 0;
}

.panel-row {
  display: flex;
  align-items: center;
  padding: 9px 20px;
  cursor: pointer;
  font-size: 13px;
  color: #4e5969;
  transition: 0.15s;
}
.panel-row:hover {
  background: rgb(var(--gray-1));
  color: #165DFF;
}
.panel-row-icon {
  margin-right: 10px;
  font-size: 16px;
  flex-shrink: 0;
  text-align: center;
  width: 18px;
}
.panel-row-danger {
  color: #f53f3f !important;
}
.panel-row-danger:hover {
  background: rgba(245, 63, 63, 0.06) !important;
  color: #c92434 !important;
}

/* ===== 主体区域 ===== */
.main-layout {
  display: flex;
  flex: 1;
  overflow: hidden;
  height: calc(100vh - 56px);
}

/* ===== 内容区 ===== */
.content-area {
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--page-bg, #f2f3f5);
}
.content-inner {
  padding: 0;
  width: 100%;
  height:auto;
  box-sizing: border-box;
}
.breadcrumb-wrap {
  margin: 10px 10px 0 10px;
}
.page-wrapper {
  margin: 20px;
  /* background: var(--card-bg, #fff);
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04); */
  /* min-height: calc(100vh - 140px); */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 900px) {
  .logo-text {
    display: none;
  }
  .user-name {
    display: none;
  }
  .top-tab span {
    display: none;
  }
}
@media (max-width: 768px) {
  .sidebar {
    position: absolute;
    z-index: 99;
    height: calc(100vh - 56px);
  }
  .top-menu-tabs {
    display: none;
  }
}

/* 多页标签栏 */
.multi-tabs-wrap {
  background: var(--card-bg, #fff);
  margin: 0;
  /* padding-top: 10px; */
  box-shadow: none;
  position: relative;
  z-index: 99;
}
.tabs-container {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border-color-light, #e5e6eb);
}
.tabs-scroll {
  flex: 1;
  overflow-x: auto;
  scrollbar-width: none;
}
.tabs-scroll::-webkit-scrollbar {
  display: none;
}
.tabs-list {
  display: flex;
  align-items: center;
  min-height: 40px;
}
.tab-item {
  display: flex;
  align-items: center;
  padding: 0 15px;
  height: 40px;
  font-size: 13px;
  color: #4e5969;
  border-right: 1px solid var(--border-color-light, #e5e6eb);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  flex-shrink: 0;
}
.tab-item:hover {
  color: #165DFF;
  background: rgba(var(--primary-6), 0.04);
}
.tab-item.active {
  color: #165DFF;
  font-weight: 500;
  background: rgba(var(--primary-6), 0.08);
  border-bottom: 2px solid #165DFF;
  margin-bottom: -1px;
}
.tab-close {
  opacity: 0.6;
  transition: opacity 0.2s;
}
.tab-item:hover .tab-close {
  opacity: 1;
}
.tabs-actions {
  padding: 0 12px;
  border-left: 1px solid var(--border-color-light, #e5e6eb);
  height: 40px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 13px;
  color: #4e5969;
  cursor: pointer;
  transition: all 0.15s;
}
.dropdown-item:hover {
  background: rgb(var(--gray-1));
  color: #165DFF;
}

/* 消息弹窗 */
.msg-popover {
  width: 340px;
  max-height: 420px;
  display: flex;
  flex-direction: column;
}
.msg-header {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  padding: 14px 16px;
  border-bottom: 1px solid #f2f3f5;
}
.msg-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  min-height: 120px;
}
.msg-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c9cdd4;
  padding: 30px 0;
  font-size: 13px;
  gap: 8px;
}
.msg-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 2px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.15s;
}
.msg-item:hover {
  background: #f7f8fa;
}
.msg-item.unread .msg-title {
  font-weight: 600;
  color: #1d2129;
}
.msg-tag {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
  display: block;
}
.msg-tag.info {
  background: #165DFF;
}
.msg-tag.warning {
  background: #ff7d00;
}
.msg-tag.success {
  background: #00b42a;
}
.msg-tag.error {
  background: #f53f3f;
}
.msg-info {
  min-width: 0;
  flex: 1;
}
.msg-title {
  font-size: 13px;
  color: #4e5969;
  line-height: 1.4;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.msg-desc {
  font-size: 12px;
  color: #86909c;
  line-height: 1.4;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.msg-time {
  font-size: 11px;
  color: #c9cdd4;
}
.msg-footer {
  text-align: center;
  padding: 10px;
  font-size: 13px;
  color: #165DFF;
  cursor: pointer;
  border-top: 1px solid #f2f3f5;
  transition: 0.15s;
}
.msg-footer:hover {
  color: #0E42D2;
}

/* 页面配置抽屉 */
.drawer-header {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}
.drawer-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #1d2129;
  padding: 16px 0 8px;
  border-top: 1px solid #f2f3f5;
  margin-top: 4px;
}
.drawer-section-title:first-child {
  border: none;
  margin-top: 0;
  padding-top: 0;
}
.drawer-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}
.drawer-label {
  font-size: 14px;
  color: #4e5969;
}
</style>

<!-- 非scoped：深色顶栏主题适配（优先级覆盖scoped样式） -->
<style>
/* 星际蓝：深色顶栏 → 白色文字/图标 */
body[arco-theme="blue"] .navbar .logo-text { color: rgba(255,255,255,.92) !important; }
body[arco-theme="blue"] .navbar .top-tab { color: rgba(255,255,255,.82) !important; }
/* 侧边栏菜单emoji图标正常显示 */
.arco-menu-icon > span:not([class*="arco-icon"]) { font-size: inherit !important; }
.arco-sub-menu .arco-menu-icon span { display: inline-flex !important; font-size: 16px !important; }
body[arco-theme="blue"] .navbar .top-tab:hover { color: #fff !important; background: rgba(255,255,255,.12) !important; }
body[arco-theme="blue"] .navbar .top-tab.active {
  color: #165DFF !important;
  font-weight: 700 !important;
  background: #fff !important;
  border-radius: 6px 6px 0 0 !important;
  border-bottom-color: transparent !important;
  box-shadow: 0 -2px 8px rgba(0,0,0,.18) !important;
}
body[arco-theme="blue"] .navbar .action-btn { color: rgba(255,255,255,.85) !important; }
body[arco-theme="blue"] .navbar .action-btn:hover { background: rgba(255,255,255,.15) !important; color: #fff !important; }

/* 修复弹出层hover时多余滚动条 */
.arco-dropdown-list-wrapper {
  max-height: none !important;
  scrollbar-width: none !important;
  overflow-y: auto !important;
}
.arco-dropdown-list-wrapper::-webkit-scrollbar {
  display: none !important; width: 0 !important; height: 0 !important;
}

/* 清除缓存确认按钮鼠标事件样式 */
.clear-cache-confirm-btn {
  position: relative;
  overflow: hidden;
}
.clear-cache-confirm-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
.clear-cache-confirm-btn:focus:not(:active)::after {
  animation: ripple 1s ease-out;
}
@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(25, 25);
    opacity: 0.3;
  }
  100% {
    transform: scale(40, 40);
    opacity: 0;
  }
}
.clear-cache-confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 63, 63, 0.3);
}
.clear-cache-confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(245, 63, 63, 0.2);
}

/* 清除缓存确认按钮鼠标事件样式 */
.clear-cache-confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 63, 63, 0.35);
}
.clear-cache-confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(245, 63, 63, 0.25);
}
</style>


<template>
  <div class="layout-container">

    <!-- ========== 顶部导航栏 ========== -->
    <nav class="navbar">
      <div class="logo-area" @click="$router.push('/index')">
        <div class="logo-icon">智</div>
        <span class="logo-text">慧园区数字化平台</span>
      </div>

      <!-- 一级菜单 Tab -->
      <div class="top-menu-tabs" v-if="menuList.length > 0">
        <div v-for="(menu, idx) in menuList" :key="'tab-'+idx"
          class="top-tab" :class="{active: currentApp === menu.info?.url}"
          @click="switchTopMenu(menu)">
          <!-- SVG图标用svg-icon组件，否则用Arco图标组件 -->
          <svg-icon v-if="isSvgIcon(menu.info?.icon)" :name="getSvgIconName(menu.info?.icon)" size="16" :color="(currentApp === menu.info?.url) ? 'rgb(var(--primary-6))' : ''" />
          <component v-else :is="resolveIcon(menu.info?.icon||'ios-menu')" style="font-size:16px;" />
          <span>{{ menu.info?.name }}</span>
        </div>
      </div>

      <div class="navbar-right">
        <!-- <a-tooltip content="刷新"><div class="action-btn" @click="location.reload()"><icon-refresh /></div></a-tooltip> -->
        <a-tooltip :content="isFullscreen ? '退出全屏' : '全屏'">
          <div class="action-btn" @click="toggleFullscreen">
            <icon-fullscreen-exit v-if="isFullscreen" /><icon-fullscreen v-else />
          </div>
        </a-tooltip>

        <a-popover trigger="click" position="br" :arrow-style="{display:'none'}">
          <div class="action-btn" style="position:relative;">
            <icon-notification />
            <span class="msg-dot" v-if="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
          </div>
          <template #content>
            <div class="msg-popover">
              <div class="msg-header">消息</div>
              <div class="msg-body">
                <template v-if="messageList.length > 0">
                  <div v-for="(msg, idx) in messageList" :key="'msg'+idx"
                    class="msg-item" :class="{unread:!msg.read}" @click="readMessage(idx)">
                    <span :class="'msg-tag '+msg.type"></span>
                    <div class="msg-info">
                      <div class="msg-title">{{ msg.title }}</div>
                      <div class="msg-desc">{{ msg.content }}</div>
                      <div class="msg-time">{{ msg.time }}</div>
                    </div>
                  </div>
                </template>
                <div v-else class="msg-empty"><icon-notification style="font-size:36px;color:#e5e6eb;" /><p>暂无消息</p></div>
              </div>
              <div class="msg-footer" v-if="messageList.length > 0" @click="readAllMessages">全部已读</div>
            </div>
          </template>
        </a-popover>

        <!-- 主题切换下拉 -->
        <a-dropdown trigger="click" position="br">
          <div class="action-btn">
            <icon-sun-fill v-if="themeMode==='light'" />
            <icon-moon-fill v-else-if="themeMode==='dark'" />
            <icon-cloud v-else-if="themeMode==='blue'" />
            <icon-brush v-else-if="themeMode==='cyber'" />
            <icon-compass v-else-if="themeMode==='orange'" />
            <icon-heart-fill v-else-if="themeMode==='green'" />
            <icon-brush v-else-if="themeMode==='purple'" />
            <icon-star-fill v-else />
          </div>
          <template #content>
            <div style="padding:4px 0;min-width:150px;">
              <div v-for="item in themeList" :key="item.key"
                   class="theme-option" :class="{active: themeMode === item.key}"
                   @click="setThemeMode(item.key)">
                <icon-sun-fill v-if="item.icon==='sun'" />
                <icon-moon-fill v-else-if="item.icon==='moon'" />
                <icon-cloud v-else-if="item.icon==='cloud'" />
                <icon-brush v-else-if="item.icon==='brush'" />
                <icon-compass v-else-if="item.icon==='compass'" />
                <icon-heart-fill v-else-if="item.icon==='heart'" />
                <icon-brush v-else-if="item.icon==='brush'" />
                <icon-star-fill v-else /><span>{{ item.label }}</span>
              </div>
            </div>
          </template>
        </a-dropdown>
        <a-tooltip content="设置"><div class="action-btn" @click="showSettingsDrawer = true"><icon-settings /></div></a-tooltip>
        <a-tooltip content="帮助"><div class="action-btn" @click="$router.push('/help')"><icon-question-circle /></div></a-tooltip>

        <a-dropdown trigger="click" position="br">
          <div class="user-trigger">
            <a-avatar :size="28" style="background:linear-gradient(135deg,#165DFF,#0E42D2);color:#fff;font-weight:600;">
              {{ ($store.state.user.nickname||'管').charAt(0) }}
            </a-avatar>
            <span class="user-name">{{ $store.state.user.nickname || '管理员' }}</span>
            <icon-down style="color:#86909c;font-size:12px;" />
          </div>
          <template #content>
            <div class="user-panel">
              <div class="panel-user-info">
                <a-avatar :size="38" style="background:linear-gradient(135deg,#165DFF,#0E42D2);color:#fff;font-weight:700;font-size:16px;">
                  {{ ($store.state.user.nickname||'管').charAt(0) }}
                </a-avatar>
                <div class="panel-detail">
                  <div class="panel-name">{{ $store.state.user.nickname || '管理员' }}</div>
                  <div class="panel-desc">{{ $store.state.user.email || 'admin@fan.com' }}</div>
                </div>
              </div>
              <div class="panel-divider"></div>
              <div class="panel-row" @click="$router.push('/home')"><span class="panel-row-icon"><icon-home /></span>工作台</div>
              <div class="panel-row" @click="bindClearStorage"><span class="panel-row-icon"><icon-eraser /></span>清除缓存</div>
              <div class="panel-row" @click="showMenu=!showMenu"><span class="panel-row-icon"><icon-eye /></span>{{ showMenu ? '隐藏菜单' : '显示菜单' }}</div>
              <div class="panel-divider"></div>
              <div class="panel-row panel-row-danger" @click="bindLogout"><span class="panel-row-icon"><icon-export /></span>退出登录</div>
            </div>
          </template>
        </a-dropdown>
      </div>
    </nav>

    <!-- ========== 主体：左侧菜单 + 右侧内容 ========== -->
    <div class="main-layout">

      <aside v-if="showMenu && !$route.hideSidebar && sideMenus.length > 0"
             :style="{height:'100%', transition:'width 0.2s'}">
        <a-menu
          ref="sideMenuRef"
          :style="{ width: isCollapsed ? '48px' : '220px', height: '100%', transition: 'width 0.2s' }"
          :open-keys="openNames"
          :selected-keys="[]"
          :collapsed="isCollapsed"
          show-collapse-button
          @collapse="onCollapse"
          @update:openKeys="onOpenKeysChange"
        >
          <template v-for="nav in sidebarMenuTree" :key="'side_' + nav.info.url">
            <!-- 有子项用可收缩子菜单 -->
            <a-sub-menu v-if="nav.hasChildren" :key="'sub_' + nav.info.url">
              <template #icon>
                <svg-icon v-if="isSvgIcon(nav.info.icon)" :name="getSvgIconName(nav.info.icon)" size="16" :color="isSubmenuActive(nav) ? 'rgb(var(--primary-6))' : 'var(--color-text-3)'" />
                <span v-else-if="isEmoji(nav.info.icon)">{{ nav.info.icon }}</span>
                <component v-else :is="resolveIcon(nav.info.icon)" :style="{ color: isSubmenuActive(nav) ? 'rgb(var(--primary-6))' : '' }" />
              </template>
              <template #title><span :style="{ color: isSubmenuActive(nav) ? 'rgb(var(--primary-6))' : '' }">{{ nav.info.name }}</span></template>
              <template v-for="child in nav.children" :key="child.info.url">
                <a-sub-menu v-if="child.hasChildren" :key="'sub2_' + child.info.url">
                  <template #icon>
                    <span v-if="isEmoji(child.info.icon)">{{ child.info.icon }}</span>
                    <component v-else :is="resolveIcon(child.info.icon)" />
                  </template>
                  <template #title>{{ child.info.name }}</template>
                  <template v-for="grandChild in child.children" :key="grandChild.info.url">
                    <a-sub-menu v-if="grandChild.hasChildren" :key="'sub3_' + grandChild.info.url">
                      <template #icon>
                        <span v-if="isEmoji(grandChild.info.icon)">{{ grandChild.info.icon }}</span>
                        <component v-else :is="resolveIcon(grandChild.info.icon)" :style="{ color: (activeMenu === grandChild.info.url) ? 'rgb(var(--primary-6))' : '' }" />
                      </template>
                      <template #title>{{ grandChild.info.name }}</template>
                      <a-menu-item
                        v-for="deepChild in grandChild.children"
                        :key="deepChild.info.url"
                        :class="{ 'arco-menu-selected': activeMenu === deepChild.info.url }"
                        @click.stop.prevent="handleMenuClick(deepChild.info.url)"
                      >{{ deepChild.info.name }}</a-menu-item>
                    </a-sub-menu>
                    <a-menu-item
                      v-else
                      :key="grandChild.info.url"
                      :class="{ 'arco-menu-selected': activeMenu === grandChild.info.url }"
                      @click.stop.prevent="handleMenuClick(grandChild.info.url)"
                    >
                      <template #icon>
                        <svg-icon v-if="isSvgIcon(grandChild.info.icon)" :name="getSvgIconName(grandChild.info.icon)" size="16" :color="(activeMenu === grandChild.info.url) ? 'rgb(var(--primary-6))' : 'var(--color-text-3)'" />
                        <span v-else-if="isEmoji(grandChild.info.icon)">{{ grandChild.info.icon }}</span>
                        <component v-else :is="resolveIcon(grandChild.info.icon)" :style="{ color: (activeMenu === grandChild.info.url) ? 'rgb(var(--primary-6))' : '' }" />
                      </template>
                      {{ grandChild.info.name }}
                    </a-menu-item>
                  </template>
                </a-sub-menu>
                <a-menu-item
                  v-else
                  :key="child.info.url"
                  :class="{ 'arco-menu-selected': activeMenu === child.info.url }"
                  @click.stop.prevent="handleMenuClick(child.info.url)"
                >
                  <template #icon>
                    <svg-icon v-if="isSvgIcon(child.info.icon)" :name="getSvgIconName(child.info.icon)" size="16" :color="(activeMenu === child.info.url) ? 'rgb(var(--primary-6))' : 'var(--color-text-3)'" />
                    <span v-else-if="isEmoji(child.info.icon)">{{ child.info.icon }}</span>
                    <component v-else :is="resolveIcon(child.info.icon)" :style="{ color: (activeMenu === child.info.url) ? 'rgb(var(--primary-6))' : '' }" />
                  </template>
                  {{ child.info.name }}
                </a-menu-item>
              </template>
            </a-sub-menu>
            <!-- 无子项直接显示 -->
            <a-menu-item
              v-else
              :key="'item_' + nav.info.url"
              :class="{ 'arco-menu-selected': activeMenu === nav.info.url }"
              @click.stop.prevent="handleMenuClick(nav.info.url)"
            >
              <template #icon>
                <svg-icon v-if="isSvgIcon(nav.info.icon)" :name="getSvgIconName(nav.info.icon)" size="16" :color="(activeMenu === nav.info.url) ? 'rgb(var(--primary-6))' : 'var(--color-text-3)'" />
                <span v-else-if="isEmoji(nav.info.icon)">{{ nav.info.icon }}</span>
                <component v-else :is="resolveIcon(nav.info.icon)" :style="{ color: (activeMenu === nav.info.url) ? 'rgb(var(--primary-6))' : '' }" />
              </template>
              {{ nav.info.name }}
            </a-menu-item>
          </template>
        </a-menu>
      </aside>

      <aside v-else-if="showMenu && !$route.meta.hideSidebar && sideMenus.length === 0"
             style="width:220px;background:var(--menu-bg,#fff);border-right:1px solid var(--border-color-light,#e5e6eb);display:flex;align-items:center;justify-content:center;color:#c9cdd4;font-size:13px;flex-shrink:0;">暂无菜单</aside>

      <!-- 右侧内容区 -->
      <section class="content-area">
        <div class="content-inner">
          <!-- 多页标签栏 -->
          <div class="multi-tabs-wrap" v-if="settings.showMultiTabs && tabVisited.length > 0">
            <div class="tabs-container">
              <div class="tabs-scroll" ref="tabsScroll">
                <div class="tabs-list">
                  <div v-for="tab in tabVisited" :key="tab.path"
                       class="tab-item" :class="{ active: tabActive === tab.path }"
                       @click="switchTab(tab)">
                    <!-- SVG/Emoji/Arco图标 -->
                    <svg-icon v-if="isSvgIcon(tab.icon)" :name="getSvgIconName(tab.icon)" size="14" :color="(tabActive === tab.path) ? 'rgb(var(--primary-6))' : ''" style="margin-right:4px;" />
                    <span v-else-if="isEmoji(tab.icon)" style="font-size:14px;margin-right:4px;">{{ tab.icon }}</span>
                    <component v-else :is="resolveIcon(tab.icon||'ios-menu')" style="font-size:14px;margin-right:4px;" />
                    <span>{{ tab.name }}</span>
                    <icon-close
                      v-if="tab.closable !== false"
                      class="tab-close"
                      @click.stop="removeTab(tab)"
                      :style="{ fontSize: '12px', marginLeft: '4px', color: '#86909c' }"
                    />
                  </div>
                </div>
              </div>
              <div class="tabs-actions" v-if="tabVisited.length > 1">
                <a-dropdown trigger="click" position="br">
                  <icon-down style="font-size:14px;color:#4e5969;cursor:pointer;" />
                  <template #content>
                    <div style="padding:4px 0;min-width:120px;">
                      <div class="dropdown-item" @click="closeOtherTabs(tabActive)">
                        <icon-close-circle style="font-size:14px;" />关闭其他
                      </div>
                      <div class="dropdown-item" @click="closeAllTabs">
                        <icon-minus-circle style="font-size:14px;" />关闭全部
                      </div>
                      <a-divider style="margin:4px 0;" />
                      <div class="dropdown-item" @click="refreshCurrent">
                        <icon-refresh style="font-size:14px;" />刷新当前
                      </div>
                    </div>
                  </template>
                </a-dropdown>
              </div>
            </div>
          </div>

          <div class="breadcrumb-wrap" v-if="breadcrumbList.length > 0 && settings.showBreadcrumb && !isHideBreadcrumb">
            <a-breadcrumb>
              <a-breadcrumb-item v-for="(item,i) in breadcrumbList" :key="i">
                <span v-if="i===breadcrumbList.length-1">{{ item.name }}</span>
                <router-link v-else :to="item.path">{{ item.name }}</router-link>
              </a-breadcrumb-item>
            </a-breadcrumb>
          </div>

          <div class="page-wrapper" v-if="activeMenu">
            <router-view v-slot="{ Component }">
              <transition name="fade" mode="out-in" v-if="settings.enableAnimation">
                <keep-alive v-if="settings.keepAlive"><component :is="Component" /></keep-alive>
                <component v-else :is="Component" />
              </transition>
              <template v-else>
                <keep-alive v-if="settings.keepAlive"><component :is="Component" /></keep-alive>
                <component v-else :is="Component" />
              </template>
            </router-view>
          </div>
        </div>
      </section>
    </div>

    <!-- 页面配置抽屉 -->
    <a-drawer :visible="showSettingsDrawer" :width="360" placement="right"
               :unmount-on-close="false" :footer="false" :mask-closable="true"
               @cancel="showSettingsDrawer=false">
      <template #title><span class="drawer-header">页面配置</span></template>
      <div>
        <div class="drawer-section-title">外观</div>
        <div class="drawer-item">
          <span class="drawer-label">主题风格</span>
          <div style="display:flex;gap:10px;flex-wrap:wrap;">
            <a-tooltip v-for="item in themeList" :key="item.key" :content="item.label" position="top">
              <div
                :style="{width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',background:item.bg,border:themeMode===item.key?'3px solid #333':'2px solid transparent',transition:'all 0.15s'}"
                @click="setThemeMode(item.key)" />
            </a-tooltip>
          </div>
        </div>
        <div class="drawer-section-title">设置</div>
        <div class="drawer-item"><span class="drawer-label">侧边栏收缩</span><a-switch v-model="settings.sidebarCollapsed" @change="saveSettings" size="small" /></div>
        <div class="drawer-item"><span class="drawer-label">面包屑导航</span><a-switch v-model="settings.showBreadcrumb" @change="saveSettings" size="small" /></div>
        <div class="drawer-item"><span class="drawer-label">动画效果</span><a-switch v-model="settings.enableAnimation" @change="saveSettings" size="small" /></div>
        <div class="drawer-item"><span class="drawer-label">页面缓存</span><a-switch v-model="settings.keepAlive" @change="saveSettings" size="small" /></div>
        <div class="drawer-item"><span class="drawer-label">多页标签</span><a-switch v-model="settings.showMultiTabs" @change="toggleMultiTabs" size="small" /></div>
        <div class="drawer-section-title">其他</div>
        <div class="drawer-item"><span class="drawer-label">色弱模式</span><a-switch v-model="settings.colorWeak" @change="saveSettings" size="small" /></div>
        <div class="drawer-item"><span class="drawer-label">灰度模式</span><a-switch v-model="settings.grayscale" @change="applyGrayscale" size="small" /></div>
      </div>
    </a-drawer>
  </div>
</template>


<script>
export default {
  name: 'LayoutMain',
  data() {
    return {
      menuList: [],
      allRouters: {},
      sideMenus: [],

      isCollapsed: (function(){ try { return localStorage.getItem('menuCollapsed') === 'true' } catch(e){ return false } })(),
      showMenu: true,
      activeMenu: '',
      openNames: [],
      currentApp: '',
      breadcrumbList: [],
      isFullscreen: false,

      // 多页标签相关
      tabVisited: [], // 本地缓存，用于计算显示
      tabActive: '',

      showSettingsDrawer: false,
      settings: this._loadSettings(),
      messageList: this._loadMsgs(),
      /* 主题列表 */
      themeMode: 'light', // 会在 created 中从 settings 初始化
      themeList: [
        { key: 'light',   label: '亮色模式',   icon: 'sun',     bg: '#ffffff' },
        { key: 'dark',    label: '暗色模式',   icon: 'moon',    bg: '#1a1a1a' },
        { key: 'blue',    label: '星际蓝',     icon: 'cloud',   bg: '#165DFF' },
        { key: 'cyber',   label: '科技风',     icon: 'brush', bg: '#0FC6C2' },
        { key: 'orange',  label: '星宇橙',     icon: 'compass',    bg: '#FF7D00' },
        { key: 'green',   label: '护眼绿',     icon: 'heart',   bg: '#00B42A' },
        { key: 'purple',  label: '紫罗兰',     icon: 'star',    bg: '#9E4DC6' },
      ],
    };
  },

  created() {
    // 从settings恢复主题模式
    this.themeMode = this.settings.themeMode || 'light'
    // 侧边栏收缩状态从 settings 初始化，确保与设置同步
    this.isCollapsed = this.settings.sidebarCollapsed
    // 初始化多页标签
    this._initTabs()
    this._loadMenu()
  },

  mounted() {
    try { this.openNames = JSON.parse(localStorage.getItem('menuOpenKeys') || '[]') } catch(e) {}
    // 恢复主题
    var mode = this.themeMode
    if (mode !== 'light') {
      document.body.setAttribute('arco-theme', mode)
    }
    
    // 初始化标签页
    this._initTabs()
    
    // 尝试设置菜单状态（应对异步加载的路由数据）
    const trySetMenu = () => {
      if (this.allRouters && Object.keys(this.allRouters).length > 0) {
        const currentPath = this.$route.path.split('?')[0]
        // 直接设置 activeMenu，:class 会自动更新高亮
        this.activeMenu = currentPath
        this._updateMenuOpenKeys(currentPath)
        return true
      }
      return false
    }
    
    // 立即尝试 + 延迟多次尝试
    trySetMenu()
    let count = 0
    const timer = setInterval(() => {
      count++
      if (trySetMenu() || count >= 10) {
        clearInterval(timer)
      }
    }, 50)
  },

  computed: {
    unreadCount() { return this.messageList.filter(m => !m.read).length },

    /** 当前路由是否隐藏面包屑 */
    isHideBreadcrumb() {
      const p = this.$route.path.split('?')[0]
      return !!this.allRouters[p]?.info?.hideBreadcrumb
    },

    /** 预构建侧边栏完整菜单树（去重、结构化），避免模板中重复查询 */
    sidebarMenuTree() {
      if (!this.sideMenus.length) return []
      const seen = new Set()
      const buildChildren = (parentUrl) => {
        const pi = this.allRouters[parentUrl]?.info
        // 如果父级设置了 showChild=false，不显示子菜单
        if (pi && pi.showChild === false) return []
        if (!pi?.path) return []
        const pl = pi.path.length
        const result = []
        Object.values(this.allRouters).forEach(item => {
          if (!item.info?.path) return
          if (item.info.path.length !== pl + 1) return
          if (item.info.url === parentUrl) return
          // path前缀必须匹配父节点
          if (item.info.path.slice(0, pl).join('/') !== pi.path.join('/')) return
          // 去重
          if (seen.has(item.info.url)) return
          seen.add(item.info.url)
          // 递归构建子节点
          const grandChildren = buildChildren(item.info.url)
          result.push({
            info: item.info,
            hasChildren: grandChildren.length > 0,
            children: grandChildren,
          })
        })
        return result
      }
      // 确保有子项的父级菜单默认展开
      const tree = this.sideMenus.map(nav => {
        const children = buildChildren(nav.info.url)
        return {
          info: nav.info,
          hasChildren: children.length > 0,
          children: children,
        }
      })
      return tree
    },
  },

  watch: {
    '$store.state.routers'(newVal) { 
      this._loadMenu()
      
      // 路由数据加载完成后，延迟设置菜单状态
      if (newVal && Object.keys(newVal).length > 0) {
        const currentPath = this.$route.path.split('?')[0]
        
        // 延迟确保 DOM 已更新
        setTimeout(() => {
          this.activeMenu = currentPath
          this._updateMenuOpenKeys(currentPath)
        }, 50)
      }
    },
    '$route'(to) {
      const path = to.path.split('?')[0]
      
      // 立即设置高亮
      this.activeMenu = path
      
      // 更新面包屑和标签
      this._updateBc(to)
      this._handleTabChange(to)
      
      // 解析当前应用和菜单
      if (this.allRouters && Object.keys(this.allRouters).length > 0) {
        this._resolveRoute()
      }
    },
    '$store.state.visitedTabs'(val) { this.tabVisited = val },
    '$store.state.activeTab'(val) { this.tabActive = val },
  },

  methods: {
    resolveIcon(n) {
      if (!n) return 'icon-apps'
      return 'icon-' + n.replace(/^icon-/i, '')
    },
    isSvgIcon(icon) {
      return icon && icon.startsWith('svg-')
    },
    getSvgIconName(icon) {
      if (this.isSvgIcon(icon)) {
        return icon.replace('svg-', '')
      }
      return ''
    },
    isEmoji(icon) {
      return icon && !this.isSvgIcon(icon) && icon.indexOf('icon-') !== 0
    },

    /** 判断 sub-menu 是否包含当前选中项（递归查找所有后代） */
    isSubmenuActive(nav) {
      if (!nav) return false
      const check = (node) => {
        if (!node) return false
        if (node.info && node.info.url === this.activeMenu) return true
        if (node.children && node.children.length > 0) {
          return node.children.some(c => check(c))
        }
        return false
      }
      return check(nav)
    },

    /* ==================== 导航 ==================== */

    /** 安全导航：只跳转到有实际页面模板的路由，避免404 */
    navigateTo(url) {
      if (!url || url === this.$route.path) return
      const info = this.allRouters[url]?.info
      if (!info) return
      
      // 立即设置高亮状态（关键！）
      this.activeMenu = url
      
      // 如果有模板页面直接跳转
      if (info.hasTmp) {
        this.$router.push(url)
        return
      }
      // 如果没有模板（是中间导航层），找第一个有模板的子页面
      const childUrl = this._findFirstTemplate(url)
      if (childUrl) { 
        this.activeMenu = childUrl  // 更新为实际跳转的目标URL
        this.$router.push(childUrl) 
      }
    },

    _findFirstTemplate(parentUrl) {
      // BFS查找最近的有模板的子路由
      const visited = new Set()
      const queue = [parentUrl]
      while (queue.length > 0) {
        const cur = queue.shift()
        if (visited.has(cur)) continue
        visited.add(cur)
        const info = this.allRouters[cur]?.info
        if (info?.hasTmp && cur !== parentUrl) return cur
        // 把所有子路由加入队列
        for (const url in this.allRouters) {
          const ci = this.allRouters[url].info
          if (ci?.path && url.startsWith(cur + '/') && !visited.has(url)) queue.push(url)
        }
      }
      return null
    },

    /* ==================== 菜单数据加载 ==================== */

    _loadMenu() {
      const routers = this.$store.state.routers || {}
      // console.log('[Layout] _loadMenu called, routers count:', Object.keys(routers).length)
      
      if (!routers || Object.keys(routers).length === 0) return
      this.allRouters = routers
      const all = Object.values(routers)
      this.menuList = all.filter(i => i.info?.type === 'app')
      
      // 解析当前应用
      this._resolveRoute()
      this._updateBc(this.$route)
      
      // 设置标签页
      this._handleTabChange(this.$route)
      
      // console.log('[Layout] _loadMenu completed, allRouters keys:', Object.keys(this.allRouters))
    },

    _resolveRoute() {
      const p = this.$route.path.split('?')[0]
      // 1) 找到当前URL属于哪个app（精确匹配：p === app.url 或 p 以 app.url + '/' 开头）
      let app = null
      for (const m of this.menuList) {
        if (!m.info) continue
        const appUrl = m.info.url
        if (p === appUrl || p.startsWith(appUrl + '/')) { app = m; break }
      }
      if (!app && this.menuList[0]) app = this.menuList[0]

      // 2) 切换到该app（加载侧边栏）
      if (app) {
        this.currentApp = app.info?.url
        const pk = app.info?.path?.[0]
        if (pk) {
          this.sideMenus = Object.values(this.allRouters).filter(i =>
            i.info?.type === 'nav' && i.info?.path?.[0] === pk
          )
        } else { this.sideMenus = [] }
      }

      // 3) 根据当前URL反向定位侧边栏高亮和展开状态
      this._restoreMenuState(p)
    },

    /** 根据当前URL计算：activeMenu高亮 + openNames展开 */
    _restoreMenuState(currentPath) {
      let activePath = currentPath
      // 如果父级设置了 showChild=false（子菜单不显示），则将高亮回退到父级
      const parentPath = currentPath.substring(0, currentPath.lastIndexOf('/'))
      if (parentPath) {
        const parentInfo = this.allRouters[parentPath]?.info
        if (parentInfo && parentInfo.showChild === false) {
          activePath = parentPath
        }
      }
      this.activeMenu = activePath
      this._updateMenuOpenKeys(currentPath)
    },
    
    /** 更新菜单的展开状态 */
    _updateMenuOpenKeys(currentPath) {
      // 计算所有父级菜单，自动展开当前路径的父级
      const parentPaths = []
      let path = currentPath
      while (path.includes('/')) {
        const lastSlash = path.lastIndexOf('/')
        if (lastSlash <= 0) break
        path = path.substring(0, lastSlash)
        if (path && this.allRouters[path]) {
          parentPaths.push(path)
        }
      }
      
      // 合并用户手动展开的状态和自动展开的父级
      const savedOpenNames = JSON.parse(localStorage.getItem('menuOpenKeys') || '[]')
      const autoOpenNames = [...new Set([...parentPaths, ...savedOpenNames])]
      
      // 只有当 openNames 变化时才更新，避免无限循环
      if (JSON.stringify(this.openNames) !== JSON.stringify(autoOpenNames)) {
        this.openNames = autoOpenNames
      }
    },

    /** 检查 target 是否是 ancestor 的后代（URL前缀匹配） */
    _isDescendant(target, ancestor) {
      if (target === ancestor) return true
      return target.startsWith(ancestor + '/')
    },

    _switchApp(app, silent) {
      this.currentApp = app.info?.url
      // 加载侧边栏菜单：当前app下的 type=nav 二级菜单
      const pk = app.info?.path?.[0]
      if (pk) {
        this.sideMenus = Object.values(this.allRouters).filter(i =>
          i.info?.type === 'nav' && i.info?.path?.[0] === pk
        )
      } else { this.sideMenus = [] }
      if (!silent) {
        const fp = this._findAppFirst(app)
        if (fp && this.$route.path !== fp) this.$router.push(fp)
      }
    },

    switchTopMenu(app) { this._switchApp(app, false) },

    _findAppFirst(app) {
      const pk = app.info?.path?.[0]; if (!pk) return null
      // 找到该app下最浅层的有模板路由（即第一个有页面的子菜单）
      let best = null; let bestLen = Infinity
      for (const url in this.allRouters) {
        const info = this.allRouters[url].info
        if (info?.path?.[0] === pk && info.hasTmp) {
          const len = info.path?.length || 0
          if (len < bestLen) { best = url; bestLen = len }
        }
      }
      return best
    },

    /** 获取某菜单的直属子项（path多一层），带去重 + 过滤空节点 — 保留供外部调用 */
    getMenuChildren(pUrl) {
      const pi = this.allRouters[pUrl]?.info; if (!pi?.path) return []
      const pl = pi.path.length
      const seen = new Set()
      return Object.values(this.allRouters).filter(i => {
        if (!i.info?.path || i.info.path.length !== pl + 1) return false
        if (i.info.url === pUrl) return false // 排除自身
        if (!i.info.path.slice(0, pl).join('/') === pi.path.join('/')) return false
        // 去重：同一url只出现一次
        if (seen.has(i.info.url)) return false
        seen.add(i.info.url)
        return true
      })
    },

    getChildMenus(pUrl) { return this.getMenuChildren(pUrl) },

    /* ==================== UI控制 ==================== */

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
      try { localStorage.setItem('menuCollapsed', String(this.isCollapsed)) } catch(e) {}
    },

    onCollapse(v) {
      this.isCollapsed = v
      try { localStorage.setItem('menuCollapsed', String(v)) } catch(e) {}
    },

    onOpenKeysChange(keys) {
      this.openNames = keys
      try { localStorage.setItem('menuOpenKeys', JSON.stringify(keys)) } catch(e) {}
    },

    /** 菜单项点击 - 统一处理高亮和导航 */
    handleMenuClick(url) {
      // 1. 设置 activeMenu（:class 会自动响应式更新高亮）
      this.activeMenu = url
      
      // 2. 执行导航
      if (url && url !== this.$route.path) {
        this.navigateTo(url)
      }
      
      // 3. 更新展开状态
      this._updateMenuOpenKeys(url)
    },

    toggleFullscreen() {
      const d = document.documentElement
      if (!this.isFullscreen) {
        (d.requestFullscreen || d.mozRequestFullScreen || d.webkitRequestFullscreen)?.call(d)
        this.isFullscreen = true
      } else {
        (document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen)?.call(document)
        this.isFullscreen = false
      }
    },

    _updateBc(route) {
      const ri = this.allRouters[route.path]
      if (ri?.info?.breadcrumb) {
        this.breadcrumbList = ri.info.breadcrumb.map(b => ({ name: b.name, path: b.url }))
        return
      }
      const bc = []; let cur = ''
      route.path.split('/').filter(Boolean).forEach(seg => {
        cur += '/' + seg; const mi = this.allRouters[cur]?.info
        if (mi) bc.push({ name: mi.name, path: cur })
      })
      this.breadcrumbList = bc
    },

    /* 清除缓存 */
    bindClearStorage() {
      this.$modal.confirm({
        title: '确认清除',
        content: '确定要清除所有本地缓存数据吗？页面将重新加载。',
        okText: '确定清除',
        cancelText: '取消',
        // 弹窗内容区域样式 - 减小间距
        bodyStyle: { 
          padding: '10px 20px',
          fontSize: '13px',
          lineHeight: '1.5'
        },
        // 确认按钮样式 - 去掉圆角
        okButtonProps: {
          type: 'primary',
          status: 'danger',
          shape: 'square',
          style: { 
            minWidth: '76px',
            borderRadius: '2px',
            transition: 'all 0.15s'
          },
          class: 'clear-cache-confirm-btn'
        },
        // 取消按钮样式 - 去掉圆角
        cancelButtonProps: {
          shape: 'square',
          style: { 
            minWidth: '76px',
            borderRadius: '2px',
            transition: 'all 0.15s'
          }
        },
        onOk: () => {
          localStorage.clear()
          sessionStorage.clear()
          if ('caches' in window) { caches.keys().then(names => names.forEach(name => caches.delete(name))) }
          this.$message.success('缓存已清除，正在刷新...')
          setTimeout(() => location.reload(), 500)
        },
      })
    },

    bindLogout() {
      localStorage.removeItem('token'); localStorage.removeItem('token-session'); localStorage.removeItem('user-role')
      this.$message.success('已退出登录'); location.reload()
    },

    /* ==================== 设置 ==================== */

    _loadSettings() {
      try {
        const s = JSON.parse(localStorage.getItem('layoutSettings') || '{}')
        return { sidebarCollapsed:false, showBreadcrumb:true, enableAnimation:true, keepAlive:true, colorWeak:false, grayscale:false, darkMode:false, themeMode:'light', themeColor:'#165DFF', showMultiTabs:false, ...s }
      } catch(e) { return { sidebarCollapsed:false, showBreadcrumb:true, enableAnimation:true, keepAlive:true, colorWeak:false, grayscale:false, darkMode:false, themeMode:'light', themeColor:'#165DFF', showMultiTabs:false } }
    },

    saveSettings() {
      localStorage.setItem('layoutSettings', JSON.stringify(this.settings))
      // 同步侧边栏收缩状态到UI
      this.isCollapsed = this.settings.sidebarCollapsed
      try { localStorage.setItem('menuCollapsed', String(this.settings.sidebarCollapsed)) } catch(e){}
    },

    applyGrayscale(v) { this.saveSettings(); document.body.style.filter = v ? 'grayscale(100%)' : '' },

    setThemeMode(mode) {
      if (!mode || this.themeMode === mode) return
      this.themeMode = mode
      this.settings.themeMode = mode
      this.saveSettings()
      /* 所有主题的 attr 映射 */
      var tMap = { light:'', dark:'dark', blue:'blue', cyber:'cyber', orange:'orange', green:'green', purple:'purple' }
      var el = document.body
      var attr = tMap[mode] || ''
      if (attr) { el.setAttribute('arco-theme', attr) }
      else { el.removeAttribute('arco-theme') }
    },

    toggleDarkMode() {
      this.setThemeMode(this.settings.darkMode ? 'light' : 'dark')
    },

    toggleMultiTabs(checked) {
      this.settings.showMultiTabs = checked
      this.saveSettings()
    },

    /* ==================== 消息 ==================== */

    _loadMsgs() { try { return JSON.parse(localStorage.getItem('messageList') || '[]') } catch(e) { return [] } },
    saveMessages() { try { localStorage.setItem('messageList', JSON.stringify(this.messageList)) } catch(e) {} },
    readMessage(idx) { if (this.messageList[idx]) { this.messageList[idx].read = true; this.saveMessages() } },
    readAllMessages() { this.messageList.forEach(m => m.read = true); this.saveMessages() },

    /* ==================== 多页标签 ==================== */
    
    /** 初始化标签页 */
    _initTabs() {
      // 从 localStorage 恢复
      try {
        const saved = localStorage.getItem('visitedTabs')
        if (saved) {
          const tabs = JSON.parse(saved)
          // 先清空 store 中的旧数据
          this.$store.state.visitedTabs = []
          this.$store.state.activeTab = ''
          // 恢复所有保存的标签
          tabs.forEach((tab, idx) => this.$store.commit('ADD_VISITED_TAB', idx === 0 ? { ...tab, closable: false } : tab))
          // 设置活跃标签：优先使用当前路由路径
          const currentPath = this.$route.path.split('?')[0]
          const currentTabExists = tabs.find(tab => tab.path === currentPath)
          this.$store.commit('SET_ACTIVE_TAB', currentTabExists ? currentPath : (tabs[0]?.path || ''))
        }
      } catch(e) {}
    },
    
    /** 处理路由变化，添加或激活标签 */
    _handleTabChange(route) {
      const path = route.path.split('?')[0]
      const info = this.allRouters[path]?.info
      
      if (!info) return
      
      // 只检查是否有模板（hasTmp 或），不再限制 type
      const hasTemplate = !!info.hasTmp || !!(info.template && info.template !== '')
      
      // 如果没有模板，不添加标签
      if (!hasTemplate) return
      
      const tab = {
        path: path,
        name: info.name || route.name || '未命名',
        icon: info.icon || 'ios-menu',
        closable: info.closable !== false,
      }
      
      // 第一个标签不可关闭
      if (this.$store.state.visitedTabs.length === 0) {
        tab.closable = false
      }
      
      this.$store.commit('ADD_VISITED_TAB', tab)
      this.$store.commit('SET_ACTIVE_TAB', path)
      
      // 保存到 localStorage
      try {
        localStorage.setItem('visitedTabs', JSON.stringify(this.$store.state.visitedTabs))
      } catch(e) {}
    },
    
    /** 切换标签 */
    switchTab(tab) {
      if (this.$route.path !== tab.path) {
        this.$router.push(tab.path)
      }
      this.$store.commit('SET_ACTIVE_TAB', tab.path)
    },
    
    /** 关闭标签 */
    removeTab(tab) {
      if (this.$store.state.visitedTabs.length <= 1) {
        this.$message.warning('至少保留一个标签页')
        return
      }
      
      this.$store.commit('REMOVE_VISITED_TAB', tab.path)
      
      // 如果关闭的是当前激活标签，切换到相邻标签
      if (tab.path === this.$store.state.activeTab) {
        const remaining = this.$store.state.visitedTabs
        if (remaining.length > 0) {
          const lastTab = remaining[remaining.length - 1]
          this.$router.push(lastTab.path)
          this.$store.commit('SET_ACTIVE_TAB', lastTab.path)
        } else {
          this.$store.commit('SET_ACTIVE_TAB', '')
        }
      }
      
      // 保存到 localStorage
      try {
        localStorage.setItem('visitedTabs', JSON.stringify(this.$store.state.visitedTabs))
      } catch(e) {}
    },
    
    /** 关闭其他标签 */
    closeOtherTabs(keepPath) {
      this.$store.commit('REMOVE_OTHER_TABS', keepPath)
      this.$store.commit('SET_ACTIVE_TAB', keepPath)
      
      // 保存到 localStorage
      try {
        localStorage.setItem('visitedTabs', JSON.stringify(this.$store.state.visitedTabs))
      } catch(e) {}
    },
    
    /** 关闭全部标签（保留第一个） */
    closeAllTabs() {
      const tabs = this.$store.state.visitedTabs
      if (tabs.length <= 1) return
      const first = tabs[0]
      this.$store.commit('REMOVE_ALL_TABS')
      this.$store.commit('ADD_VISITED_TAB', first)
      this.$store.commit('SET_ACTIVE_TAB', first.path)
      
      // 保存到 localStorage
      try { localStorage.setItem('visitedTabs', JSON.stringify([first])) } catch(e) {}
      
      // 跳转到第一个标签
      if (this.$route.path !== first.path) {
        this.$router.push(first.path)
      }
    },
    
    /** 刷新当前标签 */
    refreshCurrent() {
      location.reload()
    },
  },
};
</script>
